import {AccessDeniedException, InsufficientAuthenticationException} from "../core";
import {ErrorInfo} from "@firefly/fly-http";


export const AuthenticationExceptions = {
    fullAuthenticationIsRequired: function(reason: any) {
        return new InsufficientAuthenticationException("Full authentication is required", reason)
    },
    insufficientAuthenticationException: function(reason: string | ErrorInfo) {
        let message: string;
        if (typeof reason === "string") {
            message = reason;
        } else {
            message = reason.message;
        }
        return new InsufficientAuthenticationException(message, reason);
    }
}

export const AccessDeniedExceptions = {
    accessDenied: function(message: string, detail?: any) {
        return new AccessDeniedException(message, detail)
    }
}